export default "__VITE_ASSET__b004cc23__"